module.exports = __webpack_public_path__ + "img/tampa_screen.e1694296.png";